import type { AllRouteEndpoints } from "../routeTypes";
export const adminImpersonateCacheKeys: AllRouteEndpoints[] = [];
